const number = {
	install(Vue, options) {

		Vue.prototype.$number = {
			format: function(value, precision = 2) {
				return parseFloat(value.toFixed(precision))
			},
			average: function(array) {
				if (array.length === 0) {
					return 0;
				}
				const result = array.reduce((total, score) => total + score) / array.length;
				return result;
			},
			random: function(max, min) {
				return (Math.random() * (max - min + 1)) + min;
			},
			randomInt: function (max, min) {
				return Math.floor(this.random(max, min));
			}
		}
	}
};

export default number;
